<div class="screeners-dropdown">
  <div
    [class.pressed]="showDropdown"
    class="iv-select"
    (click)="toggleDropdown($event)"
    statistic
    [statisticElementName]="'Screener toggle dropdown'"
  >
    <span class="label">{{label}}</span>
    <span class="separator">|</span>
    <input
      class="value"
      [readonly]=true
      placeholder="All instruments"
      [value]="screenerValue"
    >
    <i class="material-icons"></i>
  </div>
  <ul *ngIf="showDropdown">
    <li
      (click)="onScreenersItemClick(screener)"
      statistic
      [statisticElementName]="'Screeners item click'"
      [id]="'screenersItem'"
      *ngFor="let screener of screenersViewModel"
    >{{screener.name}}</li>
  </ul>
</div>

<dx-popup
  [(visible)]="configureScreenerPopupVisible"
  [closeOnOutsideClick]="true"
  [dragEnabled]="false"
  [height]="'auto'"
  [position]="{ my: 'left top', at: 'bottom', of: '#screenersItem'}"
  [shading]="false"
  [showCloseButton]="false"
  [showTitle]="false"
  [width]="210"
  class="configure-screener-popup"
>
  <div
    tabindex="-1"
    (keyup.enter)="applyBtnCheck() ? onPopupApply() : null"
    (keyup.escape)="onPopupCancel('configureScreenerPopupVisible')"
    *dxTemplate="let data of 'content'"
    class="configure-screener-container"
    #popupContainer
  >

    <div class="title-tooltip-container">
      <span class="dx-popup-custom-title">{{screenerName}}</span>
      <img
        [id]="'screener-description-img'"
        src="../../../../iv-live/assets/img/screener-tooltip-icon.png"
        alt=""
        (mouseover)="screenerDescriptionPopup = true"
        (mouseout)="screenerDescriptionPopup = false"
      >
    </div>

    <div class="fields">

      <div
        class="ivx-dropdown field"
        *ngIf="screenerTypeName === 'BREAKING_OUT_IVS' || screenerTypeName === 'COLLAPSING_IVS'"
      >
        <div
          class="iv-select"
          statistic
          [statisticElementName]="'Toggle terms dropdown'"
        >
          <div class="iv-select__title">
            Choose IVX term
          </div>
          <input
            (click)="toggleTermsDropdown()"
            [readonly]=true
            class="value"
            [value]="termName"
          >
          <i
            (click)="toggleTermsDropdown()"
            class="material-icons"
          ></i>
        </div>
        <ul *ngIf="showTermsDropdown">
          <li
            statistic
            [statisticElementName]="'Screeners on terms item click'"
            (click)="onTermsItemClick(term)"
            *ngFor="let term of termsViewModel"
          >{{term.name}}</li>
        </ul>
      </div>

      <div
        class="trade-date-period-dropdown field"
        *ngIf="screenerTypeName === 'BREAKING_OUT_IVS' || screenerTypeName === 'COLLAPSING_IVS'"
      >
        <div
          class="iv-select"
          statistic
          [statisticElementName]="'Screeners toggle trade periods dropdown'"
        >
          <div class="iv-select__title">
            Choose period
          </div>
          <input
            (click)="toggleTradeDatePeriodsDropdown()"
            [readonly]=true
            class="value"
            [value]="tradeDatePeriodName"
          >
          <i
            (click)="toggleTradeDatePeriodsDropdown()"
            class="material-icons"
          ></i>
        </div>
        <ul *ngIf="showTradeDatePeriodsDropdown">
          <li
            (click)="onTradeDatePeriodsItemClick(tradeDatePeriod)"
            *ngFor="let tradeDatePeriod of tradeDatePeriodsViewModel"
          >{{tradeDatePeriod.name}}</li>
        </ul>
      </div>

      <div
        class="period-dropdown field"
        *ngIf="screenerTypeName === 'HIGH_CALL_VOLUME' || screenerTypeName === 'HIGH_PUT_VOLUME'"
      >
        <div
          [class.pressed]="showTradeDatePeriodsDropdown"
          class="iv-select"
        >
          <div class="iv-select__title">
           Choose period
          </div>
          <input
            (click)="togglePeriodsDropdown()"
            [readonly]=true
            class="value"
            [value]="periodName"
          >
          <i
            (click)="togglePeriodsDropdown()"
            class="material-icons"
          ></i>
        </div>
        <ul *ngIf="showPeriodsDropdown">
          <li
            (click)="onPeriodItemClick(period)"
            *ngFor="let period of periodsViewModel"
          >{{period.name}}</li>
        </ul>
      </div>

      <div
        class="field"
        style="display: flex; justify-content: space-between; align-items: center;"
        *ngIf="screenerTypeName === 'BREAKING_OUT_IVS' || screenerTypeName === 'COLLAPSING_IVS'"
      >
        <div  class="iv-select__title">
          Enter percent
        </div>
        <input
          class="percent-textfield"
          (input)="percentInput($event)"
          [(ngModel)]="percent"
        />
      </div>
    </div>
    <div class="buttons-container">
      <button
        (click)="onPopupApply()"

        class="iv-flat-button button apply"
        [class.disabled]="!applyBtnCheck()"
      >
        <span>Apply</span>
      </button>
      <div
        (click)="onPopupCancel('configureScreenerPopupVisible')"
        class="iv-flat-button iv-flat-button-alert button cancel"
      >
        <span>Cancel</span>
      </div>
    </div>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="screenerDescriptionPopup"
  [dragEnabled]="false"
  [height]="'auto'"
  [position]="{ my: 'left top', at: 'bottom', of: '#screener-description-img'}"
  [shading]="false"
  [showCloseButton]="false"
  [showTitle]="false"
  [width]="210"
  class="screener-description-popup"
>
  <div
    *dxTemplate="let data of 'content'"
    class="screener-description-container"
  >
    <p class="screeners-description">{{screenerDescription}}</p>
  </div>
</dx-popup>
